import React, { useEffect, useRef, useState } from "react";
import { PolarAngleAxis, PolarGrid, Radar, RadarChart } from "recharts";

const ResultRadarChart: React.VFC<{ data: any }> = (props) => {
    const [width, setWidth] = useState(null);
    const elm = useRef(null);

    const data = Object.keys(props.data).map((key) => ({
        subject: key,
        A: props.data[key] + 20,
        B: 170,
        fullMark: 170,
    }));

    useEffect(() => {
        setTimeout(() => {
            setWidth(elm.current.getBoundingClientRect().width);

            // 最下部のテキストがかぶるライブラリのバグ対応
            // https://www.pivotaltracker.com/story/show/180745699
            // @ts-ignore
            const qs = document.querySelector(
                "#rootResult > div > div:nth-child(2) > div.RadarChart > div > div > svg > g.recharts-layer.recharts-polar-angle-axis > g > g:nth-child(5) > text > tspan"
            );
            if (!!qs) {
                qs.setAttribute("dy", "1em");
            }
        }, 300);
    }, []);

    return (
        <div className="w-full mt-10 scale-75 md:scale-100 md:-mt-40" ref={elm}>
            {!!width && (
                <RadarChart
                    className="mx-auto"
                    cx={width / 2}
                    cy={width / 2}
                    outerRadius={150}
                    width={width}
                    height={width}
                    data={data}
                >
                    <PolarAngleAxis dataKey="subject" />
                    <Radar
                        name="FillBackground"
                        dataKey="B"
                        fill="#FFF"
                        fillOpacity={1}
                    />
                    <Radar
                        name="Score"
                        dataKey="A"
                        stroke="#A4AABB"
                        fill="#A4AABB"
                        fillOpacity={1}
                    />
                    <PolarGrid stroke="#FFF" fill="#FFF" />
                </RadarChart>
            )}
        </div>
    );
};

export default ResultRadarChart;
